import Service from '@/shared/classes/service'

export default class CompanyInstructionTemplateService extends Service {
  static prefix = 'company-instruction-templates'

  static destroy(id: number): Promise<any> {
    return this.delete(`/${ this.prefix }/${ id }`)
  }

  static show(id: number): Promise<any> {
    return this.get(`/${ this.prefix }/${ id }`)
  }
}
